import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  background-color: #32373d;
  color: #fff;
  border-radius: 7px;
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  bottom: 0;
  width: 100%;
  max-width: 700px;
  width: 90%;
  padding: 20px;
  position: fixed;
  top: auto;
  transform: translate3d(-50%, -10%, 0);
  flex-direction: column;

  ${mediaQuery('small')} {
    text-align: center;
    padding: 10px 0px 10px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.p`
  margin: 0;
  border-radius: 5px;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 1.8;
  margin-right: 15px;

  ${mediaQuery('small')} {
    font-size: 12px;
    margin-right: 0px;
  }
`;

export const CustomizeButton = styled.button`
  display: inline-block;
  margin-top: 7px;
  font-weight: 400;
  color: ${(props) => props.theme.color.light.default};
  padding-bottom: 1px;

  &:hover {
    border-bottom: 1px solid ${(props) => props.theme.color.light.default};
    cursor: pointer;
    padding-bottom: 0;
  }

  ${mediaQuery('small')} {
    font-size: 12px;
    margin-top: 10px;
  }
`;

export const OkButton = styled.button`
  background-color: #fff;
  color: #000;
  border-radius: 5px;

  cursor: pointer;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 700;
  height: max-content;

  letter-spacing: 0.2px;
  margin: 10px auto 0;
  padding: 10px 20px;
  margin-right: 10px;

  ${mediaQuery('small')} {
    margin-top: 10px;
    padding: 10px 20px;
    font-weight: 400;
    font-size: 13px;
  }
`;
